import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from '../../i18n/react';
import { acquireScrollLock, releaseScrollLock } from './modalScrollLock';

interface Props {
  src: string;
  onClose: () => void;
}

export function ImageLightbox({ src, onClose }: Props) {
  // Shared close-action label ("Close"/"Cerrar"), resolved at render time so
  // a runtime language switch relabels the open viewer without remounting.
  // The image itself is user content and stays verbatim (alt deliberately "").
  const { t } = useTranslation('common');
  useEffect(() => {
    acquireScrollLock();
    function onKeyDown(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose();
    }
    window.addEventListener('keydown', onKeyDown);
    return () => {
      releaseScrollLock();
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [onClose]);

  if (typeof document === 'undefined') return null;

  return createPortal(
    <div
      onClick={onClose}
      style={{
        position:       'fixed',
        inset:          0,
        zIndex:         2000,
        background:     'rgba(0,0,0,0.85)',
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        padding:        24,
        cursor:         'zoom-out',
      }}
    >
      <img
        src={src}
        alt=""
        onClick={e => e.stopPropagation()}
        style={{
          maxWidth:     '90vw',
          maxHeight:    '90vh',
          borderRadius: 10,
          boxShadow:    '0 25px 60px -20px rgba(0,0,0,0.8)',
          cursor:       'default',
        }}
      />
      <button
        type="button"
        aria-label={t('action.close')}
        onClick={onClose}
        style={{
          position:       'fixed',
          top:            20,
          right:          24,
          width:          40,
          height:         40,
          borderRadius:   '50%',
          background:     'rgba(255,255,255,0.12)',
          border:         'none',
          color:          '#FFFFFF',
          fontSize:       20,
          cursor:         'pointer',
          display:        'flex',
          alignItems:     'center',
          justifyContent: 'center',
        }}
      >
        ✕
      </button>
    </div>,
    document.body,
  );
}
